export default __webpack_public_path__ + "static/Natural_Light_Indoor_5120kbps-a0b0cf28a37e8d535a5232a70112271a.avif";